/**
 * Akamai Header utility
 *
 * Will return specified Akamai header values.
 * regEx Pattern example  = /\b(zip=)([0-9]{5})/ig;
 */

const X_AKAMAI_EDGESCAPE = 'x-akamai-edgescape';
export default function getAkamaiHeaderValue(headerObj, regExPattern) {
    try {
        if (headerObj && Object.keys(headerObj).length > 0) {
            const headerString = headerObj[X_AKAMAI_EDGESCAPE];
            if (headerString) {
                const matchArray = headerString.match(regExPattern);
                if (Array.isArray(matchArray) && matchArray.length > 0) {

                    return (matchArray[0].split('='))[1];
                }
            }
        }
        return '';
    } catch (error) {
        return '';
    }
}